import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listSegment: [],
  dataMember: {},
  active: false,
  totalSegment: 0,
  isDelete: 0,
  activeId: "",
  totalRecord: null,
  isLoadingPagi: false,
};

const slice = createSlice({
  name: "lcm",
  initialState,
  reducers: {
    createSegment() {},
    updateSegment() {},
    deleteSegment() {},
    getListSegment() {},
    getListSegmentSuccess(state, action) {
      state.listSegment = action.payload;
    },
    getDataMember() {},
    getDataMemberSuccess(state, action) {
      state.dataMember = action.payload;
    },
    activeSegment() {},
    deactiveSegment() {},
    getActiveSegment() {},
    getActiveSegmentSuccess(state, action) {
      state.active = action.payload;
    },
    updateTotalSegment(state, action) {
      state.totalSegment = action.payload;
    },
    updateIsDelete(state, action) {
      state.isDelete = action.payload;
    },
    regenerateSegmentMember() {},
    updateActiveId(state, action) {
      state.activeId = action.payload;
    },
    updateTotalRecord(state, action) {
      state.totalRecord = action.payload;
    },
    updateLoadingPagi(state, action) {
      state.isLoadingPagi = action.payload;
    },
    regenerate() {},
    updateMember() {},
    deleteMember() {},
  },
});
export default slice.reducer;

export const {
  createSegment,
  updateSegment,
  deleteSegment,
  getListSegment,
  getListSegmentSuccess,
  activeSegment,
  deactiveSegment,
  getActiveSegment,
  getActiveSegmentSuccess,
  updateTotalSegment,
  updateIsDelete,
  regenerateSegmentMember,
  getDataMember,
  getDataMemberSuccess,
  updateActiveId,
  updateTotalRecord,
  updateLoadingPagi,
  regenerate,
  updateMember,
  deleteMember,
} = slice.actions;
